/* c8 ignore start */
import cards from "./cards";
import lures from "./lures";

export default {
  cards,
  lures,
};
/* c8 ignore end */
